import { Title } from '../../basic/help/title';
import { Image } from '../../basic/help/image';
import { ProcedureFormat } from '../../basic/help/procedureFormat';
import { Step } from  '../../basic/help/step';
import { Text } from '../../basic/help/text';
import issueRefreshTokenImg1 from '../../../img/manual/issueRefreshToken/issueRefreshTokenImg1.svg';

export const IssueRefreshToken = () => {
  return (
    <div>
      <Title>認証情報の発行</Title>
      <Text>
        RICOH Chatbot Service アプリ連携を使用するための認証情報を発行します。<br />
        この手順は初回ログイン時のみ実施してください。
      </Text>
      <ProcedureFormat>
        <Step>[許可する]ボタンをクリックします。</Step>
        <Image src={issueRefreshTokenImg1} alt="issueRefreshTokenImg1" width={60} />
      </ProcedureFormat>
    </div>
  );
};
